import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as actions from './AppUser.ducks';

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  return Object.assign({}, stateProps, dispatchProps, ownProps);
};

const DEFAULT_USER = {};

const AppUser = ({
  addUserToStore,
  user = DEFAULT_USER,
  accountId,
  isAccountThreatLevelEnabled
}) => {

  useEffect(() => {
    addUserToStore({ user, accountId, isAccountThreatLevelEnabled });
  }, []);

  return <span />;
};

AppUser.propTypes = {
  user: PropTypes.object,
  accountId: PropTypes.string,
  addUserToStore: PropTypes.func,
  isAccountThreatLevelEnabled: PropTypes.bool
};

export default connect(null, actions, mergeProps)(AppUser);
